<script context="module" lang="ts">
  import type { Writable } from 'svelte/store';

  export interface AccordionContext {
    selected: Writable<HTMLDivElement | null>;
  }
</script>

<script lang="ts">
  import { setContext } from 'svelte';
  import { writable } from 'svelte/store';

  const context: AccordionContext = {
    selected: writable()
  };

  setContext<AccordionContext>('accordion', context);
</script>

<div class="accordion">
  <slot></slot>
</div>

<style>
  :root {
    --accordion-height-fallback: 100%;
  }

  .accordion {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>
